import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { updateTask } from 'api/task.service';
import { useToast } from 'hooks/ui';
import { Task } from 'models/task.model';
import { setDraftTask } from 'store/task.store';

type HookArgs = {
  keepActive?: boolean;
};

type MutationFnArgs = {
  id: string;
  task: Task;
};

export const useTaskUpdateQuery = (props: HookArgs = { keepActive: false }) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isLoading, mutate } = useMutation(
    ({ id, task }: MutationFnArgs) =>
      updateTask(id, {
        title: task.title,
        description: task.description,
        errorMessage: task.errorMessage,
        validator: task.validator,
        workModels: task.workModels,
        ...(task.validator === 'CONTAINS'
          ? { answer: task.answer }
          : { answer: null }),
      }),
    {
      onSuccess: (task) => {
        queryClient.invalidateQueries(['tasks']);
        toast.success('Task has been drafted successfully');

        if (props.keepActive) {
          setDraftTask(task);
        }
      },
      onError: (error: AxiosError) => {
        toast.error(error.message);
      },
    },
  );

  return { isLoading, mutate };
};
